const downloadFile = ({data, fileName}) => {
  // This is how you download a file using axios -> https://gist.github.com/javilobo8/097c30a233786be52070986d8cdb1743 :)
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export default downloadFile;
